import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { capabilityCards, serviceChain } from '@/mocks/about';

export default function Capabilities() {
  return (
    <section id="capabilities" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="华辉数智能力矩阵"
            en="Capability Matrix"
            subtitle="AI 应用、数字商业、IoT 连接与系统集成，构成完整的技术服务链。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {capabilityCards.map((card, i) => (
            <Reveal key={card.title} delay={i * 100}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${card.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-foreground-950">{card.title}</h3>
                <div className="mt-1 text-sm text-primary-600 font-medium">{card.desc}</div>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{card.detail}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={150}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            {serviceChain.map((step, i) => (
              <div key={step} className="flex items-center gap-3">
                <div className="px-5 py-2.5 rounded-md bg-accent-100 text-accent-900 text-sm font-medium whitespace-nowrap">
                  {step}
                </div>
                {i < serviceChain.length - 1 && (
                  <i className="ri-arrow-right-line text-foreground-400"></i>
                )}
              </div>
            ))}
          </div>
          <p className="mt-4 text-center text-xs text-foreground-500">研发 → 集成 → 部署 → 运维</p>
        </Reveal>
      </div>
    </section>
  );
}